import { render } from "./AppUpdateModal.vue?vue&type=template&id=52b7b038&scoped=true"
import script from "./AppUpdateModal.vue?vue&type=script&lang=js"
export * from "./AppUpdateModal.vue?vue&type=script&lang=js"

import "./AppUpdateModal.vue?vue&type=style&index=0&id=52b7b038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b7b038"]])

export default __exports__